// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { MatomoProvider, createInstance } from '@datapunt/matomo-tracker-react'; // <-- Importar
import './index.css';
import App from './App';
import './i18n'; // Importar config i18n

// --- Crear Instancia de Matomo ---
const matomoInstance = createInstance({
  urlBase: process.env.REACT_APP_MATOMO_URL, // Lee desde .env
  siteId: parseInt(process.env.REACT_APP_MATOMO_SITE_ID || '0', 10), // Lee desde .env y convierte a número
  trackerUrl: `${process.env.REACT_APP_MATOMO_URL}matomo.php`, // Asume /matomo.php (común)
  srcUrl: `${process.env.REACT_APP_MATOMO_URL}matomo.js`, // Asume /matomo.js (común)
  disabled: !process.env.REACT_APP_MATOMO_URL || !process.env.REACT_APP_MATOMO_SITE_ID, // Deshabilitar si falta config
  linkTracking: true, // Habilitar seguimiento de clics en enlaces de salida
  configurations: {
    // Opcional: Configuraciones adicionales del tracker de Matomo
    // Por ejemplo, para asegurar cookies seguras si tu app usa HTTPS
    // disableCookies: false,
    // setSecureCookie: window.location.protocol === 'https:',
    // etc.
  }
});
// --------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* --- Envolver App con MatomoProvider --- */}
    <MatomoProvider value={matomoInstance}>
      <React.Suspense fallback={<div>Loading...</div>}>
        <App />
      </React.Suspense>
    </MatomoProvider>
    {/* -------------------------------------- */}
  </React.StrictMode>
);